export const numberWithDelimiter = (number, options = {}) => {
  if (typeof Intl !== 'object' || typeof Intl.NumberFormat !== 'function') {
    return number.toString();
  }
  return new Intl.NumberFormat('en', options).format(number);
};

export const isNumber = (number) => typeof number === 'number';
